import React from 'react';
import './styles.css';
import CardHelper from "../../helpers";

function CardPlanSelector(props) {
    return (
        <div className={'card card-planSelector'}>
            <div className={'card-container'}>
                <div className={'preview-container'}>
                    {
                        props.portrait !== '' &&
                            <div
                                className='card-cover'
                                style={{ backgroundImage: `url(${props.portrait})` }}
                            />
                    }
                    <div className='container-logo-addOn'>
                        {CardHelper.createLogoPlansAddOn(props.logo)}
                    </div>
                    <div className='card-labels-container'>
                        {CardHelper.createFooterPlanSelector(props)}
                    </div>
                    {
                        CardHelper.createButtonPlanSelector(props.id, props.groupId, props)
                    }
                </div>
            </div>
        </div>
    );
}

export default CardPlanSelector;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardPlanSelector/index.js